<template>
  <div id="evaluation" class="evaluation" >
    <rise-loader color="rgb(39, 139, 172)" v-if="evaluations.length == 0"></rise-loader>
    <div v-if="evaluations[activeCourseCode] != null" style="margin-left: 20px;margin-right: 20px;margin-bottom: 20px;margin-top:-30px">
      <b-row v-if="activity"  class="justify-content-center align-items-center">
        <b-col cols="2"><b-btn v-on:click="switchComponent('task')">&laquo; {{$t('evaluation.back')}}</b-btn></b-col>
        <b-col cols="10">
          <b-row class="justify-content-center align-items-center">
            <b-col md="auto"><h1>{{activity.headline}} ({{activity.timelineDate  | moment("YYYY-MM-DD")}})</h1></b-col>
            <b-col md="auto" cols="1"><a :href="evaluationLink" target="_blank" class="cursor-pointer"><i class="fa fa-external-link"></i></a></b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <b-nav tabs v-if="evaluations[activeCourseCode] != null">
      <b-nav-item v-for='course in courses' v-bind:active="course.id == activeCourse.id" v-on:click="selectCourse(course)">{{course.code}}</b-nav-item>
    </b-nav>

    <b-container>
    </b-container>
    <b-list-group v-if="evaluations[activeCourseCode]!= null">
      <b-row>
        <b-col cols="4"><small style="margin-left:30px"><b-form-checkbox @change="selectAllEvaluations()" v-model="selectedAll" ><p class="cursor-pointer">{{$t('evaluation.student')}}</p></b-form-checkbox></small></b-col>
        <b-col cols="6"><small style="margin-left:60px">{{$t('tack.goals')}}</small></b-col>
        <b-col cols="2"><small>{{$t('evaluation.overall')}}</small></b-col>
      </b-row>
      <b-list-group-item button v-for="evaluation in evaluations[activeCourseCode]" :variant="getEvaluationVariant(evaluation)">
        <b-container class="bv-example-row">
          <b-row>
            <b-col cols="4">
              <b-row>
                <b-form-checkbox :id="evaluation.id + 'checkbox'" v-model="evaluation.selected" :disabled="evaluation.lockedDate != null" @change="selectEvaluation(evaluation)" ><p class="cursor-pointer">{{evaluation.student.firstName}} {{evaluation.student.lastName}}</p></b-form-checkbox>
              </b-row>
              <b-row>
                <span v-if="!evaluation.publishedDate" style="margin-right: 15px" v-on:click="selectedEvaluation = evaluation" class="cursor-pointer"><i class="fa fa-cloud-upload" v-b-modal="'modalPublish'"></i></span>
                <span v-if="evaluation.publishedDate" style="margin-right: 15px" v-on:click="unpublishEvaluation(evaluation)" v-b-tooltip.hover :title='evaluation.publishedDate | moment("YYYY-MM-DD")' class="cursor-pointer"><i class="fa fa-cloud-download"></i></span>

                <span v-if="!evaluation.lockedDate" v-on:click="setEvaluationLocked(evaluation)" class="cursor-pointer" style="margin-right: 15px"><i class="fa fa-unlock"></i></span>
                <span v-if="evaluation.lockedDate" v-on:click="setEvaluationUnLocked(evaluation)" class="cursor-pointer" v-b-tooltip.hover :title='evaluation.lockedDate | moment("YYYY-MM-DD")' style="margin-right: 15px"><i class="fa fa-lock"></i></span>

                <span v-if="evaluation.teacherRemark" v-on:click="getEvaluationForComments(evaluation)" class="cursor-pointer" style="margin-right: 15px"><i class="fa fa-comment" v-b-modal.modalComment></i></span>
                <span v-if="!evaluation.teacherRemark" v-on:click="getEvaluationForComments(evaluation)" class="cursor-pointer" style="margin-right: 15px"><i class="fa fa-comment-o" v-b-modal.modalComment></i></span>
                <span class="cursor-pointer" style="margin-right: 15px" v-on:click="getReport(evaluation.id)"><i class="fa fa-pencil-square-o"></i></span>
              </b-row>
            </b-col>
            <b-col cols="7" v-if="syllabuses[activeCourse.code]">
              <grade @updateEvaluation="updateEvaluation"
                     v-bind:evaluations="evaluations"
                     v-bind:evaluation="evaluation"
                     v-bind:selectedEvaluations="selectedEvaluations"
                     v-bind:activeCourseCode="activeCourseCode"
                     v-bind:syllabuses="syllabuses"
                     v-bind:activeCourse="activeCourse"
                     v-bind:market="market">
              </grade>
            </b-col>
            <b-col cols="1" class="vcenter">
              <grading-scale @updateEvaluation="updateEvaluation"
                             v-bind:evaluations="evaluations"
                             v-bind:evaluation="evaluation"
                             v-bind:selectedEvaluations="selectedEvaluations"
                             v-bind:activeCourseCode="activeCourseCode"
                             v-bind:activity="activity"
                             v-bind:market="market">
              </grading-scale>
            </b-col>
          </b-row>
        </b-container>
      </b-list-group-item>
    </b-list-group>

    <error-modal @closeModal="closeModal" v-bind:text="errorText" v-bind:errorModalShow="errorModalShow"></error-modal>
    <evaluation-comment v-bind:selectedEvaluations="selectedEvaluations"
                        v-bind:selectedEvaluation="selectedEvaluation"
                        v-bind:commentData="commentData"
                        v-bind:evaluations="evaluations[activeCourseCode]"></evaluation-comment>
    <evaluation-publish v-bind:selectedEvaluation="selectedEvaluation"></evaluation-publish>
    <b-modal ref="reportModalRef" id="modalReport" title="Report">

      <b-card-body id="nav-scroller"
                   ref="content"
                   style="position:relative; height:300px; overflow-y:scroll;">
        <span v-html="reportText"></span>
      </b-card-body>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import api from '../api'
import { RiseLoader } from 'vue-spinner/dist/vue-spinner.min.js'
import Grade from './Grade'
import EvaluationComment from './EvaluationComment'
import EvaluationPublish from './EvaluationPublish'
import EvaluationReport from './EvaluationReport'
import GradingScale from './GradingScale'
import ErrorModal from './ErrorModal'

Vue.use(require('vue-moment'))

export default {
  components: {
    RiseLoader, Grade, GradingScale, EvaluationComment, EvaluationPublish, EvaluationReport, ErrorModal
  },
  name: 'Evaluation',
  props: ['task', 'market', 'learnUrl'],
  data () {
    return {
      evaluations: [],
      courses: [],
      activity: null,
      activeCourse: null,
      activeCourseCode: null,
      activeGoalPopover: null,
      syllabuses: null,
      selectedEvaluation: null,
      commentData: {},
      selectedEvaluations: [],
      allGoals: [],
      evaluationLink: null,
      errorText: '',
      errorModalShow: false,
      reportText: null,
      selectedAll: false
    }
  },
  created () {
    api.fetchEvaluation(this.task.id).then(response => {
      if (response.error) {
        this.showError(response.error)
        return
      }
      this.courses = response.apiActivity.courses
      this.syllabuses = response.syllabuses
      this.evaluations = response.evaluations
      this.evaluationLink = this.learnUrl + response.evaluationLink
      this.activeCourse = response.apiActivity.courses[0]
      this.activeCourseCode = this.getActiveCourseCode(this.activeCourse)

      for (var i in this.syllabuses) {
        this.allGoals = this.allGoals.concat(this.syllabuses[i].goals)
      }
    })

    api.fetchActivity(this.task.id).then(response => {
      if (response.error) {
        this.showError(response.error)
        return
      }
      this.activity = response
    })
  },
  methods: {
    updateEvaluation: function (variable) {
      this.selectedEvaluations = variable
      if (this.selectedEvaluations.length === 0) {
        this.selectedEvaluations = []
      }
    },

    switchComponent: function (comp) {
      this.$emit('clicked', comp)
    },

    selectEvaluation: function (evaluation, forceSelection) {
      if (!forceSelection) {
        evaluation.selected = !evaluation.selected
      } else {
        evaluation.selected = true
      }
      this.selectedEvaluation = evaluation
      if (!evaluation.lockedDate) {
        this.changeSelectedEvaluations(evaluation, forceSelection)
      }
      this.checkIfAllEvaluationsSelected()
    },

    changeSelectedEvaluations: function (evaluation, forceSelection) {
      if (this.selectedEvaluations.includes(evaluation.id)) {
        if (!forceSelection) {
          this.selectedEvaluations.splice(this.selectedEvaluations.indexOf(evaluation.id), 1)
        }
      } else {
        this.selectedEvaluations.push(evaluation.id)
      }
    },

    getEvaluationVariant: function (evaluation) {
      return this.selectedEvaluations.includes(evaluation.id) ? 'info' : ''
    },

    selectCourse: function (course) {
      this.activeCourse = course
      this.activeCourseCode = this.getActiveCourseCode(course)
    },

    getActiveCourseCode: function (activeCourse) {
      return activeCourse.yeargroup != null ? activeCourse.code + ' - ' + activeCourse.yeargroup : activeCourse.code
    },

    setEvaluationLocked: function (evaluation) {
      api.lockEvaluation(evaluation.id).then(response => {
        if (response.error) {
          this.showError(response.error)
          return
        }
        evaluation.lockedDate = response
        evaluation.selected = false
      })
    },

    setEvaluationUnLocked: function (evaluation) {
      api.unlockEvaluation(evaluation.id).then(response => {
        if (response.error) {
          this.showError(response.error)
          return
        }
        evaluation.lockedDate = null
      })
    },

    unpublishEvaluation: function (evaluation) {
      api.unpublishEvaluation(evaluation.id).then(response => {
        if (response.error) {
          this.showError(response.error)
          return
        }
        evaluation.publishedDate = null
      })
    },

    showError: function (text) {
      this.errorText = text
      this.errorModalShow = true
    },

    closeModal: function (variable) {
      this.errorModalShow = variable
    },

    getReport: function (evaluationId) {
      api.getReport(evaluationId).then(response => {
        this.reportText = response.report
        this.$refs.reportModalRef.show()
      })
    },

    getEvaluationForComments: function (evaluation) {
      this.selectedEvaluation = evaluation
      this.commentData = evaluation
      this.commentData.teacherRemark = this.selectedEvaluations.length === 0 ? evaluation.teacherRemark : ''
    },

    selectAllEvaluations: function () {
      if (this.checkIfAllEvaluationsSelected()) {
        for (var i in this.evaluations[this.activeCourseCode]) {
          this.evaluations[this.activeCourseCode][i].selected = false

          var index = this.selectedEvaluations.indexOf(this.evaluations[this.activeCourseCode][i].id)
          if (index !== -1) this.selectedEvaluations.splice(index, 1)
        }
        this.selectedAll = false
      } else {
        for (var i in this.evaluations[this.activeCourseCode]) {
          if (this.selectedEvaluations.indexOf(this.evaluations[this.activeCourseCode][i].id) === -1 &&
            this.evaluations[this.activeCourseCode][i].lockedDate == null) {
            this.evaluations[this.activeCourseCode][i].selected = true
            this.selectedEvaluations.push(this.evaluations[this.activeCourseCode][i].id)
          }
        }
      }
    },

    checkIfAllEvaluationsSelected: function () {
      for (var i in this.evaluations[this.activeCourseCode]) {
        if (!this.evaluations[this.activeCourseCode][i].selected && this.evaluations[this.activeCourseCode][i].lockedDate == null) {
          this.selectedAll = false
          return false
        }
      }
      this.selectedAll = true
      return true
    }
  }
}
</script>
<style scoped>
  .cursor-pointer {
    cursor: pointer;
  }
  .vcenter {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Evaluation.vue